export default [
  { 
    title: '진리와은혜교회 소개',
    category: 'Introduction',
    description: '진리와은혜교회 소개',
    url: 'https://youtu.be/BTM2Vt7nFVo'
  },
  { 
    title: '새암교회 창립 40주년 타임라인',
    category: 'Reflection',
    description: '새암교회 창립 40주년 타임라인',
    url: 'https://youtu.be/MVkqq6OFSTY'
  },
  { 
    title: '새암교회 창립 40주년',
    category: 'Reflection',
    description: '새암교회 창립 40주년',
    url: 'https://youtu.be/mEJHrp3qx1s'
  },
  { 
    title: '송원교회 그로잉',
    category: 'Sketch',
    description: '송원교회 그로잉',
    url: 'https://youtu.be/7Q6P7iVU4vM'
  },
  { 
    title: '2026 영남신학대학교 생선컨퍼런스 현장스케치',
    category: 'Sketch',
    description: '2026 영남신학대학교 생선컨퍼런스 현장스케치',
    url: 'https://youtu.be/PpE6NB9LnSY'
  },
  {
    title: '2026 영남신학대학교 생선컨퍼런스 광고',
    category: 'Advertisement',
    description: '2026 영남신학대학교 생선컨퍼런스 광고',
    url: 'https://youtu.be/6Hc4Yq-tg4A'
  },
  {
    title: '일본선교 8기 특별기획 후기 인터뷰 - Full',
    category: 'Interview',
    description: '기쁨의교회 청년부 일본선교 8기 특별기획 후기 인터뷰 - Full',
    url: 'https://youtu.be/vbz_q7kcOIA'
  },
  {
    title: '일본선교 8기 특별기획 후기 인터뷰 - Short',
    category: 'Interview',
    description: '기쁨의교회 청년부 일본선교 8기 특별기획 후기 인터뷰 - Short',
    url: 'https://youtu.be/bEbNixwhd18'
  },
  {
    title: '동성교회 2026 여름 단기선교',
    category: 'Sketch',
    description: '동성교회 2026 여름 단기선교',
    url: 'https://youtu.be/K9v8ZTmhdq0'
  },
  {
    title: '이룸교회 2026 여름성경학교 스케치',
    category: 'Sketch',
    description: '이룸교회 2026 여름성경학교 스케치',
    url: 'https://youtu.be/cf4TYZ9vE_4'
  },
  {
    title: '강릉기지교회 2026 학생부 여름성경학교 스케치',
    category: 'Sketch',
    description: '강릉기지교회 2026 학생부 여름성경학교 스케치',
    url: 'https://youtu.be/60UHsavA5vM'
  },
  {
    title: '강릉기지교회 2026 초등부 여름성경학교 스케치',
    category: 'Sketch',
    description: '강릉기지교회 2026 초등부 여름성경학교 스케치',
    url: 'https://youtu.be/j5nXgMIOUuc'
  },
  {
    title: '인도네시아 아웃리치',
    category: 'Sketch',
    description: '인도네시아 아웃리치',
    url: 'https://youtu.be/F2GQDhIpr5o'
  },
  {
    title: '2026 여름수련회 중간 스팟',
    category: 'Spot',
    description: '기쁨의교회 청년부 2026 여름수련회 중간 스팟',
    url: 'https://youtu.be/Z6oXcz1N6D8'
  },
  {
    title: '2026 여름수련회 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2026 여름수련회 광고',
    url: 'https://youtu.be/DPntRSEkh7A'
  },
  {
    title: '기쁨의교회 80주년 청년하람 기획 인터뷰',
    category: 'Interview',
    description: '기쁨의교회 80주년 청년하람 기획 인터뷰',
    url: 'https://youtu.be/gkdPSVhTYMM'
  },
  {
    title: '2026 Rebuild Recruit',
    category: 'Advertisement',
    description: '기쁨의교회 2026 Rebuild 모집 광고',
    url: 'https://youtu.be/WxnDOmpfNaQ'
  },
  {
    title: '2026 영남신학대학교 생선컨퍼런스 광고',
    category: 'Advertisement',
    description: '2026 영남신학대학교 생선컨퍼런스 광고',
    url: 'https://youtu.be/6Hc4Yq-tg4A'
  },
  {
    title: '일본선교 8기 특별기획 후기 인터뷰 - Full',
    category: 'Interview',
    description: '기쁨의교회 청년부 일본선교 8기 특별기획 후기 인터뷰 - Full',
    url: 'https://youtu.be/vbz_q7kcOIA'
  },
  {
    title: '일본선교 8기 특별기획 후기 인터뷰 - Short',
    category: 'Interview',
    description: '기쁨의교회 청년부 일본선교 8기 특별기획 후기 인터뷰 - Short',
    url: 'https://youtu.be/bEbNixwhd18'
  },
  {
    title: '동성교회 2026 여름 단기선교',
    category: 'Sketch',
    description: '동성교회 2026 여름 단기선교',
    url: 'https://youtu.be/K9v8ZTmhdq0'
  },
  {
    title: '이룸교회 2026 여름성경학교 스케치',
    category: 'Sketch',
    description: '이룸교회 2026 여름성경학교 스케치',
    url: 'https://youtu.be/cf4TYZ9vE_4'
  },
  {
    title: '강릉기지교회 2026 학생부 여름성경학교 스케치',
    category: 'Sketch',
    description: '강릉기지교회 2026 학생부 여름성경학교 스케치',
    url: 'https://youtu.be/60UHsavA5vM'
  },
  {
    title: '강릉기지교회 2026 초등부 여름성경학교 스케치',
    category: 'Sketch',
    description: '강릉기지교회 2026 초등부 여름성경학교 스케치',
    url: 'https://youtu.be/j5nXgMIOUuc'
  },
  {
    title: '인도네시아 아웃리치',
    category: 'Sketch',
    description: '인도네시아 아웃리치',
    url: 'https://youtu.be/F2GQDhIpr5o'
  },
  {
    title: '2026 여름수련회 중간 스팟',
    category: 'Spot',
    description: '기쁨의교회 청년부 2026 여름수련회 중간 스팟',
    url: 'https://youtu.be/Z6oXcz1N6D8'
  },
  {
    title: '2026 여름수련회 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2026 여름수련회 광고',
    url: 'https://youtu.be/DPntRSEkh7A'
  },
  {
    title: '기쁨의교회 80주년 청년하람 기획 인터뷰',
    category: 'Interview',
    description: '기쁨의교회 80주년 청년하람 기획 인터뷰',
    url: 'https://youtu.be/gkdPSVhTYMM'
  },
  {
    title: '2026 Rebuild Recruit',
    category: 'Advertisement',
    description: '기쁨의교회 2026 Rebuild 모집 광고',
    url: 'https://youtu.be/WxnDOmpfNaQ'
  },
  {
    title: '휘장을 찢고 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 영광송',
    url: 'https://youtu.be/JbFLmdFBU_E'
  },
  {
    title: '의료 서비스 기반 모의해킹 시나리오 3',
    category: 'Technology',
    description: 'Rookies 28기 최종프로젝트\n시나리오 3 - SSTI 기반 클라우드 침투 및 내부망 장악',
    url: 'https://youtu.be/_qO2s9B6lho'
  },
  {
    title: '의료 서비스 기반 모의해킹 시나리오 2',
    category: 'Technology',
    description: 'Rookies 28기 최종프로젝트\n시나리오 2 - 모바일 앱 분석을 통한 악성 APK 배포 및 원격제어',
    url: 'https://youtu.be/6ML-_QAkErY'
  },
  {
    title: '의료 서비스 기반 모의해킹 시나리오 1',
    category: 'Technology',
    description: 'Rookies 28기 최종프로젝트\n시나리오 1 - 챗봇을 이용한 프롬프트 인젝션 및 랜섬웨어 유포',
    url: 'https://youtu.be/JSVExSlNd6M'
  },
  {
    title: '2026 겨울수련회 중간 스팟',
    category: 'Spot',
    description: '기쁨의교회 청년부 2026 겨울수련회 중간 스팟',
    url: 'https://youtu.be/qd71rRMaYzU'
  },
  {
    title: '2026 겨울수련회 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2026 겨울수련회 광고\n참여: 영상편집',
    url: 'https://youtu.be/ti9irwVozbc'
  },
  {
    title: '의료 서비스 취약점 진단 스캐너 시연',
    category: 'Technology',
    description: 'Rookies 28기 2차 프로젝트 의료 서비스 취약점 진단 스캐너 시연',
    url: 'https://youtu.be/mKITiL1Xb6g'
  },
  {
    title: '2025 Rebuild 한 해 돌아보기',
    category: 'Reflection',
    description: '기쁨의교회 청년부 찬양팀 Rebuild의 2025년 활동 돌아보기',
    url: 'https://youtu.be/OABDOt6iLbU'
  },
  {
    title: '2025 Revive 리쿠르팅',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 미디어팀 Revive 2025년 모집 광고',
    url: 'https://youtu.be/KiUAZiQ3-l0'
  },
  {
    title: 'SafeRoad System 작품 소개',
    category: 'Technology',
    description: 'Team ROUTE의 SafeRoad System(도로 장애물 감지 및 대응 시스템) 작품 소개',
    url: 'https://youtu.be/2UAQMhu3LcI'
  },
  {
    title: '영광송 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 영광송',
    url: 'https://youtu.be/EMmpXIrdq-U'
  },
  {
    title: '기쁨의 생활선교사 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 기쁨의 생활선교사',
    url: 'https://youtu.be/4JIlTIHYmBU'
  },
  {
    title: '하나님 뜻 안에 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 하나님 뜻 안에',
    url: 'https://youtu.be/TiupMpolfh0'
  },
  {
    title: '헥시움(Hacksium) 2025 본선 참여 브이로그',
    category: 'Vlog',
    description: '동남권 해킹방어대회 헥시움(Hacksium) 2025 3일간의 본선 참여 브이로그',
    url: 'https://youtu.be/spfEYqaDVKI'
  },
  {
    title: '2025 여름수련회 중간 스팟',
    category: 'Spot',
    description: '기쁨의교회 청년부 2025 여름수련회 중간 스팟',
    url: 'https://youtu.be/whecURVR6GA'
  },
  {
    title: '2025 여름수련회 릴스 광고 2',
    category: 'Reels',
    description: '기쁨의교회 청년부 2025 여름수련회 릴스 광고 2\n참여: Reels 추출',
    url: 'https://www.youtube.com/shorts/Xqw5t_7sFgE'
  },
  {
    title: '2025 여름수련회 릴스 광고 1',
    category: 'Reels',
    description: '기쁨의교회 청년부 2025 여름수련회 릴스 광고 1',
    url: 'https://www.youtube.com/shorts/2s5RWpQgltA'
  },
  {
    title: '2025 여름수련회 2차 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2025 여름수련회 2차 광고',
    url: 'https://youtu.be/ac0XOsmFvSw'
  },
  {
    title: '2025 여름수련회 1차 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2025 여름수련회 1차 광고',
    url: 'https://youtu.be/X4OQ6ugfd6c'
  },
  {
    title: '믿음의 근원, 예수 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 믿음의 근원, 예수',
    url: 'https://youtu.be/aviBaDV2bPM'
  },
  {
    title: '2025 청결하라 현장스케치',
    category: 'Sketch',
    description: '기쁨의교회에서 진행된 2025 청결하라(청년이여 결혼하라) 현장스케치',
    url: 'https://youtu.be/FCIPtdCJNwc'
  },
  {
    title: '2025 일본선교 5기 스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 2025 일본선교 5기 스케치',
    url: 'https://youtu.be/9NCr8XD1f2M'
  },
  {
    title: '2025 겨울수련회 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2025 겨울수련회 광고',
    url: 'https://youtu.be/uyQddVr-s14'
  },
  {
    title: '2025 청년부 예배 오프닝',
    category: 'Opener',
    description: '기쁨의교회 청년부 2025 예배 오프닝',
    url: 'https://youtu.be/AbmTdi1l9Ec'
  },
  {
    title: 'The Blessing of Christmas - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - The Blessing of Christmas',
    url: 'https://youtu.be/XHXAS8R6Ka4'
  },
  {
    title: '새 하늘의 별과 같이 (Jazz ver) - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 새 하늘의 별과 같이',
    url: 'https://youtu.be/Ro3EoC0040Y'
  },
  {
    title: '산 화목제물의 삶 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 산 화목제물의 삶',
    url: 'https://youtu.be/zwjFXNr5PkM'
  },
  {
    title: '2024 The Wave 2 현장스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 주관 포항 청년 연합 찬양 버스킹 페스티벌 2회 현장스케치',
    url: 'https://youtu.be/biH9-fDwBGg'
  },
  {
    title: '2024 The Wave 2 릴스 광고 2',
    category: 'Reels',
    description: '기쁨의교회 청년부 주관 포항 청년 연합 찬양 버스킹 페스티벌 2회 릴스 광고 2',
    url: 'https://www.youtube.com/shorts/92jL9w-4RO4'
  },
  {
    title: '2024 The Wave 2 릴스 광고 1',
    category: 'Reels',
    description: '기쁨의교회 청년부 주관 포항 청년 연합 찬양 버스킹 페스티벌 2회 릴스 광고 1',
    url: 'https://www.youtube.com/shorts/SmRuD5em5-8'
  },
  {
    title: '우리는 생선 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 우리는 생선',
    url: 'https://youtu.be/eQUYweKqhkI'
  },
  {
    title: '새 하늘의 별과 같이 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 새 하늘의 별과 같이',
    url: 'https://youtu.be/3o62O7idYog'
  },
  {
    title: '죽임 당하신 어린 양 - 박상엽 목사',
    category: 'Music',
    description: '기쁨의교회 박상엽 목사 작사작곡 찬양 - 죽임 당하신 어린 양',
    url: 'https://youtu.be/0f20I0YNAaU'
  },
  {
    title: '샘 곁에 심은 나무 - 스텔라 칸타빌레',
    category: 'Music',
    description: '기쁨의교회 스텔라칸타빌레 작사작곡 찬양 - 샘 곁에 심은 나무',
    url: 'https://youtu.be/Mx08Y3Y8ADI'
  },
  {
    title: '2024 여름수련회 현장스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 X 전주시온성교회 청년부 2024 연합 여름수련회 현장스케치',
    url: 'https://youtu.be/N5uI4kBo5fY'
  },
  {
    title: '2024 여름수련회 플레이리스트',
    category: 'Playlist',
    description: '기쁨의교회 청년부 2024 여름수련회 플레이리스트',
    url: 'https://youtu.be/BJ8zt1v2sQM'
  },
  {
    title: '2024 여름수련회 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 X 전주시온성교회 청년부 2024 연합 여름수련회 광고',
    url: 'https://youtu.be/6IgxLETsuDI'
  },
  {
    title: '2024 일본선교 2기 스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 2024 일본선교 2기 스케치',
    url: 'https://youtu.be/PV8k9ExKiNg'
  },
  {
    title: '2024 겨울수련회 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2024 겨울수련회 광고',
    url: 'https://youtu.be/3BPzOEJsPVg'
  },
  {
    title: '2023 크리스마스 영일대 찬양 버스킹 페스티벌',
    category: 'Advertisement',
    description: '기쁨의교회 2023 크리스마스 영일대 찬양 버스킹 페스티벌',
    url: 'https://youtu.be/fwMMM2-C5v0'
  },
  {
    title: '블링(Bling)',
    category: 'Drama',
    description: '영상기획론 강의에서 제작한 단편 드라마 블링(Bling)\n참여: 기획 및 아이디어 제공',
    url: 'https://youtu.be/S-AlJcmsQn4'
  },
  {
    title: '2023 The Wave 현장스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 주관 포항 청년 연합 찬양 버스킹 페스티벌 현장스케치',
    url: 'https://youtu.be/Ux7_PZtRQuE'
  },
  {
    title: '2023 The Wave Teaser',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 주관 포항 청년 연합 찬양 버스킹 페스티벌 티저',
    url: 'https://youtu.be/LZRAsuY_Og8'
  },
  {
    title: '2023 일본선교 1기 스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 2023 일본선교 1기 스케치',
    url: 'https://youtu.be/VncwPPAG33M'
  },
  {
    title: 'WAVE WORSHIP - 내 마음을 가득 채운',
    category: 'Campaign',
    description: 'WAVE WORSHIP - 내 마음을 가득 채운 버스킹 영상',
    url: 'https://youtu.be/iHvL5epzRDQ'
  },
  {
    title: 'WAVE WORSHIP - 돌아서지 않으리',
    category: 'Music',
    description: 'WAVE WORSHIP - 돌아서지 않으리 버스킹 영상',
    url: 'https://youtu.be/XTTprBGDtDU'
  },
  {
    title: 'WAVE WORSHIP - 아버지의 노래',
    category: 'Music',
    description: 'WAVE WORSHIP - 아버지의 노래 버스킹 영상',
    url: 'https://youtu.be/lPMlrfwIeDM'
  },
  {
    title: 'WAVE WORSHIP - 하나님의 세계',
    category: 'Music',
    description: 'WAVE WORSHIP - 하나님의 세계 버스킹 영상',
    url: 'https://youtu.be/eiBcxHXx1zs'
  },
  {
    title: 'WAVE WORSHIP Teaser',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 WAVE WORSHIP 티저',
    url: 'https://youtu.be/tIhKPIc47iY'
  },
  {
    title: '2023 겨울수련회 스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 2023 겨울수련회 스케치',
    url: 'https://youtu.be/QIH_ywpf_7w'
  },
  {
    title: '2023 청년부 특별새벽기도회 1주차 스케치',
    category: 'Sketch',
    description: '기쁨의교회 청년부 2023 특별새벽기도회 1주차 스케치',
    url: 'https://youtu.be/lVkuNXlKRiw'
  },
  {
    title: '2022 Rebuild 한 해 돌아보기',
    category: 'Reflection',
    description: '기쁨의교회 청년부 찬양팀 Rebuild의 2022년 활동 돌아보기',
    url: 'https://youtu.be/7FtX_CdJWAk'
  },
  {
    title: '2021 청년부 예배 오프닝',
    category: 'Opener',
    description: '기쁨의교회 청년부 2021 예배 오프닝',
    url: 'https://youtu.be/rAPt09PozVk'
  },
  {
    title: '한경국립대학교 SPAL Lab 소개',
    category: 'Introduction',
    description: '한경국립대학교 전기전자공학부 소속 SPAL Lab 소개',
    url: 'https://youtu.be/XHKTjzYmPCc'
  },
  {
    title: '바른역사 교사양성과정 광고',
    category: 'Advertisement',
    description: '바른역사 교사양성과정 광고',
    url: 'https://youtu.be/0v1chbSdhOk'
  },
  {
    title: '2020 여름수련회 \'회심\' 광고',
    category: 'Advertisement',
    description: '기쁨의교회 청년부 2020 여름수련회 \'회심\' 광고',
    url: 'https://youtu.be/MCpeuEtM4N4'
  },
  {
    title: '나랑 기도하러 가지 않을래? 후기',
    category: 'Sketch',
    description: '나랑 기도하러 가지 않을래? 캠페인 후기 영상',
    url: 'https://youtu.be/po-ckF00lVs'
  },
  {
    title: '나랑 기도하러 가지 않을래? 티저',
    category: 'Advertisement',
    description: '나랑 기도하러 가지 않을래? 캠페인 티저 영상',
    url: 'https://youtu.be/_WFl-D5z2Tw'
  },
  {
    title: '영적 습관 만들기 1차',
    category: 'Interview',
    description: '영적 습관 만들기 캠페인 1차 인터뷰 영상',
    url: 'https://youtu.be/uKig_EYpWdE'
  }
];
